var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareersClientImpact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.067 12.954C5.96704 13.8823 3.42871 15.914 3.42871 15.914C3.42871 15.914 4.33871 19.1157 7.13371 22.384L7.85704 23.229C8.65038 24.1573 9.04871 24.6223 9.22704 25.1956C9.40538 25.7706 9.34538 26.3906 9.22538 27.629L9.11538 28.7573C8.69371 33.119 9.75871 36.2673 9.75871 36.2673C9.75871 36.2673 12.9554 36.3523 16.792 34.5856L17.787 34.129C18.877 33.6256 19.422 33.3756 20.0004 33.3756C20.5787 33.3756 21.1237 33.6256 22.2154 34.129L23.207 34.5856C27.0454 36.3523 30.2404 36.269 30.2404 36.269C30.2404 36.269 31.307 33.119 30.8854 28.7573M32.867 22.384C35.662 19.1173 36.572 15.914 36.572 15.914C36.572 15.914 34.0337 13.8806 29.9337 12.954L28.8737 12.714C27.7087 12.4507 27.127 12.319 26.6587 11.964C26.192 11.609 25.892 11.0706 25.292 9.99398L24.7454 9.01398C22.6337 5.22732 20.0004 3.33398 20.0004 3.33398C20.0004 3.33398 17.367 5.22732 15.2554 9.01398",
    stroke: "url(#paint0_linear_1235_8201)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1235_8201",
    x1: 3.42871,
    y1: 4.24143,
    x2: 35.5779,
    y2: 41.0028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareersClientImpact);
export default __webpack_public_path__ + "static/media/Careers_Client_Impact.7ae71ac93d31459dbcfb60ac4103e437.svg";
export { ForwardRef as ReactComponent };